module.exports = __webpack_public_path__ + "img/gift4-01-c08-k1.902dba41.png";